var WDN = WDN || {};


if (typeof WDN.Popup === 'undefined') {

  WDN.Popup = (function() {

    var body = document.querySelector('body');

    var _classes = {
      isOpen: 'isOpen',
      close: ".close",
      bg: '.popup__bg',
      trigger: '.wdn-popup-trigger',
      baseClass: '.wdn-popup'
    };

    function open(elem) {
      $(_classes.bg).show();
      elem.addClass(_classes.isOpen).focus();
      body.classList.add('body--popup-open');
    };

    function close(id) {

      // lets close all popups just to be sure
      $(_classes.bg).hide();
      $(_classes.baseClass).removeClass(_classes.isOpen);
      body.classList.remove('body--popup-open');
    };

    $(_classes.bg).on('click', function() {
      close();
    });

    $(_classes.baseClass + " " + _classes.close).on("click", function(e) {
      close();
    });

    $(_classes.trigger).on("click", function(e) {
      e.preventDefault();

      var popupId = $(this).attr("href").replace("#", "");
      var $popup = $("#" + popupId + _classes.baseClass);

      if ($popup.length === 1) {
        open($popup);
      }
    });

    return {open: open, close: close}

  })();
};


// copy to clipboard functionality
(function() {

  var nodes = {
    buttons: document.querySelectorAll("[data-copy-clipboard]")
  };

  var handleButtonClick = function(e) {
    var value = this.getAttribute("data-copy-clipboard");
    navigator.clipboard.writeText(value);
    this.classList.add("text--copied");

    setTimeout(function() {
      this.classList.remove("text--copied");
    }.bind(this), 500)
  }

  nodes.buttons.forEach(function(button) {
    button.addEventListener("click", handleButtonClick);
  });

}());

// WDN Popup open from url
(function() {

  var init, open_modal, remove_param;

  var config = {
    param_name: "modal_open",
    delete_on_read: true
  };

  var search_params = new URLSearchParams(window.location.search);

  open_modal = function(){
    var param_id = search_params.get(config.param_name);
    var modal_trigger = document.querySelector("a[data-blockid='"+ param_id +"']");
    if(!modal_trigger) return;
    modal_trigger.click();  
  }

  remove_param = function(){
    if(!config.delete_on_read) return;
    search_params.delete(config.param_name);
    window.history.replaceState("", "", "?"+ search_params.toString());
  }

  init = function() {
    if (!search_params.has(config.param_name)) return;
    open_modal();
    remove_param();
  };

  init();

}());
